import React from 'react';
import ThisProject from '../ThisProject';
import { BoxLegend, ImageMedia, Section, TextBox } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className="projectContent min-h-[300vh]">


          <Section center className={"grid grid-cols-1 lg:grid-cols-2 gap-8 min-h-[50vh] resp"}>

            <ImageMedia title="m&co_pattern" src={require("./assets/Pattern_withLogo.png")} className="opacity-[.02] z-[0] absolute top-0 inset-x-0 object-top object-cover w-full" />

            <BoxLegend legend="Logo Primaire — Disposition Contractée"
              id="1stLogo" border square rounded
            >
              <ImageMedia title="macaronandcologo" src={require("./assets/1.png")} className="showLogo" />
            </BoxLegend>

            <BoxLegend legend={"Logo Secondaire — disposition étendue horizontale"}
              id="2ndLogo" border square rounded
            >
              <ImageMedia title="macaronandcologo" src={require("./assets/2.png")} className="showLogo !max-w-[62%]" />
            </BoxLegend>

            <BoxLegend legend={"Palette de couleurs"}
              id="colors" border square rounded
            >
              <ImageMedia title="colors" src={require("./assets/LAWWD_M&CO_Colors02.jpg")} className="h-full object-top object-contain" />
            </BoxLegend>
          </Section>

          <Section className={"mt-20"} >
            <ImageMedia src={require("./branding.jpg")} className="min-h-[60vh]" />
          </Section>

          <TextBox title="Design Produit"
            className="resp"
            descr={<span className='text-lg !leading-tight text-balance'>Essentiellement toujours en possession des gourmands, le produit de Macaron & Co ne peut faillir aux missions suivantes :
              <br />{/* <br /> */}
              ✨ Éveiller les sens – Avec des saveurs authentiques et une texture délicate, chaque bouchée transporte vers un moment de pur plaisir.
              <br />{/*  <br /> */}
              🎨 Séduire par le design – Un packaging raffiné qui reflète l’élégance et le savoir-faire artisanal de la marque. Chaque boîte est pensée comme un écrin mettant en valeur des macarons aussi beaux que délicieux.
              <br /> {/* <br /> */}
              🌱 Garantir la qualité – Des ingrédients soigneusement sélectionnés, sans compromis sur la fraîcheur et l’authenticité des goûts.
              <br /> {/* <br /> */}
              🎁 Offrir une expérience unique – Que ce soit pour une dégustation personnelle ou un cadeau raffiné, Macaron & Co transforme chaque occasion en un instant mémorable.
              <br /> {/* <br /> */}
              💛 Respecter les valeurs de la marque – Un équilibre parfait entre tradition et innovation, avec un engagement envers des pratiques responsables et une fabrication artisanale."
            </span>}
          />


          <Section className="mt-20" >
            <div className='grid grid-cols-2 gap-4 relative w-full'>
              <ImageMedia src={require("./assets/M&CO_Packaging_R19.jpg")} className="" />
              <ImageMedia src={require("./_cover.jpg")} className="" />
            </div>
          </Section>
        </div>
      )}
    </ThisProject>

  )
}

export default Content